import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import ItemService from "../../../../services/supplier_appCommonService";
import toast from "react-hot-toast";
import FileThumbnailForHB from "./FileThumbnailForHB";
import Loader from "../../../../Components/Loader";

const FileViewerModalForHB = React.forwardRef((props, ref) => {
  const [files, setFiles] = useState([]);
  const [status, setStatus] = useState(false);

  const loadUploadedFiles = async (attachmentId) => {
    if (!attachmentId) return;

    setStatus(true);
    try {
      const payload = { attachmentId, timeZone: "Asia/Calcutta" };
      const res = await ItemService.getUploadedFiles(payload);
      
      // ✅ FIXED: Make sure we get all files from response
      const uploadedFiles = res?.data || [];
      console.log("Loaded files:", uploadedFiles);  // Debug
      setFiles(uploadedFiles);
    } catch (err) {
      console.error("Error loading files:", err);
      toast.error("Failed to load files");
    }
    setStatus(false);
  };

  // ✅ FIXED: Proper delete handler
//   const handleDelete = async (file) => {
//     // const payload = {
//     //   fileName: file.fileName || file.newFilename,
//     //   attachmentId: props.fileid, 
//     // };
//     const payload = {
//   fileName: file.newFilename, // ✅ ALWAYS use this
//   attachmentId: props.fileid,
// };

//     try {
//       const res = await ItemService.deleteFile(payload);

//       if (res.status === 200 || res.message?.includes("deleted successfully")) {
//         toast.success("File deleted successfully");

//         // ✅ Calculate new list immediately
//         // const updatedFiles = files.filter((f) => f._id !== file._id);
//         const updatedFiles = files.filter(
//   (f) => f.newFilename !== file.newFilename
// );

//         // ✅ Update state
//         setFiles(updatedFiles);

//         // ✅ Notify parent
//         if (props.onDeleteSuccess) {
//           props.onDeleteSuccess({
//             attachmentId: props.fileid,
//             hasFiles: updatedFiles.length > 0,
//           });
//         }
//       } else {
//         toast.error(res.message || "Delete failed");
//       }
//     } catch (err) {
//       console.error("Delete error:", err);
//       toast.error("Delete failed ❌");
//     }
//   };

const handleDelete = async (file) => {
  const payload = {
    fileName: file.newFilename,
    attachmentId: props.fileid,
  };

  try {
    const res = await ItemService.deleteFile(payload);

    if (res.status === 200 || res.message?.includes("deleted successfully")) {
      toast.success("File deleted successfully");

      const updatedFiles = files.filter(
        (f) => f.newFilename !== file.newFilename
      );

      setFiles(updatedFiles);

      if (props.onDeleteSuccess) {
        props.onDeleteSuccess({
          attachmentId: props.fileid,
          hasFiles: updatedFiles.length > 0,
          remainingCount: updatedFiles.length,
        });
      }
    } else {
      toast.error(res.message || "Delete failed");
    }
  } catch (err) {
    console.error("Delete error:", err);
    toast.error("Delete failed ❌");
  }
};

  // useEffect(() => {
  //   if (props.fileid) {
  //     loadUploadedFiles(props.fileid);
  //   }
  // }, [props.fileid]);
  useEffect(() => {
  if (props.fileid && props.show) {
    loadUploadedFiles(props.fileid);
  }
}, [props.fileid, props.show]);

  return (
    <Modal
      {...props}
      dialogClassName="modal-90w"
      keyboard={false}
      centered
      backdrop="static"
      size="lg"
      ref={ref}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Attachment Files ({files.length} file{files.length !== 1 ? 's' : ''})
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Loader isLoading={status} />

          {!status && files.length > 0 ? (
            <FileThumbnailForHB files={files} onDelete={handleDelete} />
          ) : !status ? (
            <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
              No files uploaded
            </div>
          ) : null}
        </Row>
      </Modal.Body>
    </Modal>
  );
});

export default FileViewerModalForHB;
